import type { HomePageLocaleContent } from '../types'

export const homePageEn: HomePageLocaleContent = {
  seoTitle: 'Calculate. Convert. Get things done. | Toolvance',
  seoDescription: 'Fast, accurate calculators, converters and useful tools for everyday life, work, study and engineering.',
  ogDescription: 'Free engineering calculators for electrical, mechanical, thermal, energy and physics calculations.',
  tagline: 'Calculate. Convert. Get things done.',
  searchPlaceholder: "Search - try 'battery', 'torque', 'ohm'...",
  searchButton: 'Search',
  searchResultsPrefix: 'Search results for',
  resultNounSingular: 'calculator',
  resultNounPlural: 'calculators',
  noResults: 'No calculators found. Try a different search term.',
  popularHeading: 'Popular Calculators',
  viewAllPrefix: 'View all',
}
